import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "sortBy" })
export class SortByPipe implements PipeTransform {
    transform(records: Array<string>, key: any): Array<string> {

        var byVal = key.direction === 0 ? 1 : key.direction;

        if (records === undefined || records.length === 0)
            return records;

        records.sort((a: any, b: any) => {

            if ((typeof a[key.property] === "string" && typeof b[key.property] === "string")) {
                if (a[key.property] === null && b[key.property] === null) {
                    return 0;
                } else {
                    if (a[key.property].toLowerCase() < b[key.property].toLowerCase()) {
                        return (key.direction === 0) ? -1 * byVal : 1 * byVal;
                    }
                    else if (a[key.property].toLowerCase() > b[key.property].toLowerCase()) {
                        return (key.direction === 0) ? 1 * byVal : -1 * byVal;
                    }
                    else {
                        return 0;
                    }
                }
            } else {
                if (a[key.property] < b[key.property]) {
                    return (key.direction === 0) ? -1 * byVal : 1 * byVal;
                }
                else if (a[key.property] > b[key.property]) {
                    return (key.direction === 0) ? 1 * byVal : -1 * byVal;
                }
                else {
                    return 0;
                }
            }
        });
        return records;
    }
}
